import React, { useEffect, useState } from 'react'
import StudentSidebar from '../StudentSideBar/StudentSidebar'
import StudentNavbar from '../StudentNavbar/StudentNavbar'
import "./StudentDashboard.css"
import well from "../../Image/welcomescreen.png"
import StudentCourses from './StudentCourses'
import RightPanel from '../RightSidebar/RightSidebar'

function StudentDashboard() {


    const progressData = [
        { id: 1, label: "Part Typography", category: "User Interface", progress: 40, color: "#f7931e", tag: "UI" },
        { id: 2, label: "Part Operators", category: "Python", progress: 20, color: "#007bff", tag: "PY" },
        { id: 3, label: "Part Statistics", category: "Data Science", progress: 34, color: "#28a745", tag: "DS" },
        { id: 4, label: "Part Cryptocurrency", category: "Blockchain", progress: 20, color: "#dc3545", tag: "BC" },
    ];

    const [todayGoal, setTodayGoal] = useState(80);
    const [overallGoal, setOverallGoal] = useState(60);

    const CIRCLE_RADIUS = 40;
    const CIRCLE_CIRCUMFERENCE = 2 * Math.PI * CIRCLE_RADIUS;

    const todayStrokeDasharray = `${(todayGoal * CIRCLE_CIRCUMFERENCE) / 100} ${CIRCLE_CIRCUMFERENCE}`;
    const overallStrokeDasharray = `${(overallGoal * CIRCLE_CIRCUMFERENCE) / 100} ${CIRCLE_CIRCUMFERENCE}`;

    return (
        <>
            <div className='Student-main'>
                <div className='Student-sidebar'>
                    <div>
                        <StudentSidebar />
                    </div>
                </div>
                <div className='Student-nav'>
                    <StudentNavbar />


                    <div className='student-dass-admin' >
                        <div>
                            <img src={well} alt="" className='wellcome-image' />
                            <div >
                                <div className="dashboardss">
                                    <div className="progress-card">
                                        <h3 className='student-text'>Progress Learning</h3>
                                        <div className="progress-list">
                                            {progressData.map((item) => (
                                                <div className="progress-item" key={item.id}>
                                                    <span className="tag" style={{ backgroundColor: item.color }}>{item.tag}</span>
                                                    <div className="progress-info">
                                                        <strong>{item.label}</strong>
                                                        <p>{item.category}</p>
                                                        <div className="progress-bar">
                                                            <div className="progress" style={{ width: `${item.progress}%`, backgroundColor: item.color }}></div>
                                                        </div>
                                                    </div>
                                                    <span className="percentage">{item.progress}%</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="progress-container">
                                        <div className="progress-header">
                                            <div className="today-title">Today's Goal</div>
                                            <div className="score-title">Your Score looks good!</div>
                                        </div>

                                        <div className="circles-container">
                                            <div className="circle-wrapper">
                                                <svg width="120" height="120" viewBox="0 0 120 120">
                                                    <circle
                                                        cx="60"
                                                        cy="60"
                                                        r={CIRCLE_RADIUS}
                                                        fill="none"
                                                        stroke="#C5CAF9"
                                                        strokeWidth="8"
                                                    />
                                                    <circle
                                                        cx="60"
                                                        cy="60"
                                                        r={CIRCLE_RADIUS}
                                                        fill="none"
                                                        stroke="#4F5FF7"
                                                        strokeWidth="8"
                                                        strokeDasharray={todayStrokeDasharray}
                                                        strokeDashoffset={CIRCLE_CIRCUMFERENCE * 0.25}
                                                        transform="rotate(-90 60 60)"
                                                    />
                                                    <text x="60" y="55" textAnchor="middle" fontSize="18" fontWeight="bold">
                                                        {todayGoal}%
                                                    </text>
                                                    <text x="60" y="75" textAnchor="middle" fontSize="12" fill="#666">
                                                        Today's Goal
                                                    </text>
                                                </svg>
                                            </div>

                                            <div className="circle-wrapper">
                                                <svg width="120" height="120" viewBox="0 0 120 120">
                                                    <circle
                                                        cx="60"
                                                        cy="60"
                                                        r={CIRCLE_RADIUS}
                                                        fill="none"
                                                        stroke="#C7E6D9"
                                                        strokeWidth="8"
                                                    />

                                                    <circle
                                                        cx="60"
                                                        cy="60"
                                                        r={CIRCLE_RADIUS}
                                                        fill="none"
                                                        stroke="#0D8A4F"
                                                        strokeWidth="8"
                                                        strokeDasharray={overallStrokeDasharray}
                                                        strokeDashoffset={CIRCLE_CIRCUMFERENCE * 0.25}
                                                        transform="rotate(-90 60 60)"
                                                    />
                                                    <text x="60" y="55" textAnchor="middle" fontSize="18" fontWeight="bold">
                                                        {overallGoal}%
                                                    </text>
                                                    <text x="60" y="75" textAnchor="middle" fontSize="12" fill="#666">
                                                        Overall Goal
                                                    </text>
                                                </svg>
                                            </div>
                                        </div>

                                        <div className="legend-container">
                                            <div className="legend-item">
                                                <div className="legend-color today-color"></div>
                                                <div className="legend-text">Progress</div>
                                            </div>
                                            <div className="legend-item">
                                                <div className="legend-color today-bg-color"></div>
                                                <div className="legend-text">Your Goal</div>
                                            </div>
                                            <div className="legend-item">
                                                <div className="legend-color overall-color"></div>
                                                <div className="legend-text">General</div>
                                            </div>
                                            <div className="legend-item">
                                                <div className="legend-color overall-bg-color"></div>
                                                <div className="legend-text">Overall</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                        <div ><RightPanel /></div>
                    </div>




                </div>
            </div>

        </>
    )
}

export default StudentDashboard

